import React from 'react';
import { Gradient } from '../Gradient';

const Love = ({ type, className = '', color = '#737373' }) => {
  return (
   
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M22.3308 20.7255C22.3308 20.7255 21.5559 13.2432 25.8517 8.94741C30.1475 4.65164 37.1123 4.65166 41.408 8.94743C44.6581 12.1975 46.0943 18.9888 43.353 26.0001M19.0803 7.05568C14.9088 4.78888 9.58065 5.41946 6.0527 8.94741C1.75693 13.2432 -0.169168 23.7255 7.83085 32.7255C14.9464 40.7305 21.9824 42.7673 23.4512 43.1198C23.5288 43.1384 23.5676 43.1478 23.6374 43.1544C23.6852 43.159 23.7757 43.1593 23.8236 43.1549C23.8933 43.1485 23.9329 43.1392 24.0121 43.1207C25.1049 42.864 29.2402 41.7026 34 37.9447"
        stroke={type === 'plain' ? color : 'url(#globalGradient)'}
        strokeWidth="3"
        strokeLinecap="round" />
        <path d="M39.9375 26.5871C39.729 25.5667 38.271 25.5667 38.0625 26.5871C37.6018 28.8407 35.8406 30.6019 33.587 31.0626C32.5666 31.2711 32.5666 32.7291 33.587 32.9376C35.8406 33.3983 37.6018 35.1595 38.0625 37.4131C38.271 38.4335 39.729 38.4335 39.9375 37.4131C40.3982 35.1595 42.1594 33.3983 44.413 32.9376C45.4334 32.7291 45.4334 31.2711 44.413 31.0626C42.1594 30.6019 40.3982 28.8407 39.9375 26.5871Z" 
        fill={type === 'plain' ? color : 'url(#globalGradient)'} />
        <Gradient className={className} />
    </svg>

  );
};

export default Love;